(() => {
  const namespace = 'KrasisDiagnosticDifference';

  if (window[namespace]) {
    window[namespace].initAll();
    return;
  }

  const selector = '[data-krasis-diagnostic-difference]';
  const observers = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const disconnect = (section) => {
    const observer = observers.get(section);

    if (observer) {
      observer.disconnect();
      observers.delete(section);
    }
  };

  const showFinalState = (section) => {
    section.classList.remove('is-reveal-ready');
    section.classList.add('is-visible');
  };

  const init = (section) => {
    if (!section || section.dataset.diagnosticDifferenceInitialized === 'true') return;

    section.dataset.diagnosticDifferenceInitialized = 'true';
    disconnect(section);

    if (section.dataset.revealAnimation !== 'true' || reducedMotion.matches || !('IntersectionObserver' in window)) {
      showFinalState(section);
      return;
    }

    section.classList.add('is-reveal-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry?.isIntersecting) return;

        section.classList.add('is-visible');
        section.dataset.diagnosticDifferenceRevealed = 'true';
        observer.disconnect();
        observers.delete(section);
      },
      { threshold: 0.32 }
    );

    observers.set(section, observer);
    observer.observe(section);
  };

  const initAll = (root = document) => {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll?.(selector).forEach(init);
  };

  const onSectionLoad = (event) => initAll(event.target);
  const onSectionUnload = (event) => {
    const section = event.target.matches?.(selector) ? event.target : event.target.querySelector?.(selector);
    if (!section) return;

    disconnect(section);
    delete section.dataset.diagnosticDifferenceInitialized;
    section.classList.remove('is-reveal-ready', 'is-visible');
  };

  window[namespace] = { initAll };

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
})();
